import { render, staticRenderFns } from "./FiltroSolicitacoes.vue?vue&type=template&id=025afdd1&scoped=true"
import script from "./FiltroSolicitacoes.vue?vue&type=script&lang=js"
export * from "./FiltroSolicitacoes.vue?vue&type=script&lang=js"
import style0 from "./FiltroSolicitacoes.vue?vue&type=style&index=0&id=025afdd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025afdd1",
  null
  
)

export default component.exports